import React from 'react';
import { ProductImageSlider } from './ProductImageSlider';
import { PinIcon } from './Icons';

const formatNumber = (value) => new Intl.NumberFormat('en-GB').format(value);

const FacilityChip = ({ facility }) => (
  <span className="inline-flex items-start gap-2 whitespace-normal text-[14px] font-medium leading-[25px] tracking-[0] text-slate-900" style={{ fontFamily: 'var(--gp-font--matter)' }}>
    {facility.iconUrl && (
      <img
        src={facility.iconUrl}
        alt=""
        className="h-[1.125rem] w-[1.125rem] shrink-0 object-contain"
      />
    )}
    <span>{facility.label}</span>
  </span>
);

export const ProductCard = ({ product, index }) => (
  <article
    className="group overflow-hidden rounded-md bg-[#F4F6F7] shadow-[0px_1px_2px_0px_#323C4C33] transition-shadow duration-300 hover:shadow-[0px_4px_8px_0px_#323C4C40]"
    style={{ fontFamily: 'var(--gp-font--matter)' }}
  >
    <ProductImageSlider
      images={product.images}
      alt={product.name}
      index={index}
    />

    <header className="bg-[#000000] px-6 pb-5 pt-5 text-white flex flex-col gap-2 transition-colors duration-300 group-hover:bg-[#1D1D1F]">
      <div className="text-[25px] font-medium leading-none !pb-0 lg:text-[30px] lg:tracking-[0]" style={{ fontFamily: 'var(--gp-font--matter)' }}>
        {product.name}
      </div>
      <p className="my-0 flex items-center gap-1 text-[15px] font-medium leading-[27px] tracking-[0.25px] text-white lg:text-[17px]" style={{ fontFamily: 'var(--gp-font--matter)' }}>
        <PinIcon className="h-[24px] w-[20px] shrink-0 text-[#3C7AFF]" />
        <span>{product.address}</span>
      </p>
    </header>

    <div className="px-6 pb-6 pt-5">
      {product.chargingBaysLabel && (
        <p
          className="text-[17px] !font-medium leading-none tracking-[0] text-slate-900 mb-0 lg:text-[25px]"
          style={{
            fontFamily:
              "'PP Neue Montreal', var(--gp-font--matter), sans-serif",
          }}
        >
          {formatNumber(product.chargingBays)} {product.chargingBaysLabel}
        </p>
      )}

      <div className="mt-0 flex flex-col gap-4 lg:flex-row lg:items-start lg:gap-5">
        <div className="min-w-0 flex-1">
          <hr
            className="my-4 h-px border-0 opacity-50"
            style={{ backgroundColor: 'var(--Blue-extra, #3C7AFF)' }}
          />
          <div className="mt-4 flex flex-col gap-2 2xl:flex-row 2xl:flex-wrap 2xl:items-center 2xl:gap-x-4 2xl:gap-y-2">
            {product.facilities.map((facility, i) => (
              <FacilityChip key={i} facility={facility} />
            ))}
          </div>
        </div>

        {product.ctaUrl && (
          <a
            href={product.ctaUrl}
            className="relative inline-flex w-full shrink-0 items-center justify-center overflow-hidden rounded-[3px] bg-[#1F6FEB] px-5 py-1 text-[17px] leading-[30px] font-semibold text-white no-underline shadow-[0px_1px_2px_0px_#323C4C33] hover:text-white hover:no-underline focus:no-underline before:absolute before:inset-0 before:bg-brand-gradient before:transition-opacity before:duration-300 before:content-[''] hover:before:opacity-0 group-hover:before:opacity-0 lg:mt-4 lg:w-auto lg:max-w-[7.5rem] lg:self-start lg:whitespace-normal lg:px-3 lg:py-1.5 lg:text-center lg:text-[0.85rem] lg:leading-snug xl:text-[1rem]"
          >
            <span className="relative z-10" style={{ fontFamily: "'Matter-TRIAL', var(--gp-font--matter), sans-serif" }}>View details</span>
          </a>
        )}
      </div>
    </div>
  </article>
);
